import React from "react";
import Animation1 from "./Animtion1";

const Works = () => {
  const worksData = [
    {
      image: "/img/webpImg/Download.webp",
      heading: "Download the App",
      text: "Download The Best Deals App from the App Store or Google Play.",
    },
    {
      image: "/img/webpImg/Discover-Deals.webp",
      heading: "Browse the Deals that delight you",
      text: "Browse the best deals from the most popular categories and top brands.",
    },
    {
      image: "/img/webpImg/Shop.webp",
      heading: "You’re ready to shop!",
      text: "Select the deals that you love without worrying about the price.",
    },
  ];

  return (
    <div className="flex-col hidden gap-5 sm:flex">
      <Animation1 />

      <div className="text-[#FFF] bg-gradient-to-r from-[#7D53F2] to-[#A579E9] pb-44 lg:pb-48 flex flex-col gap-10">
        <div className="flex justify-between">
          <img
            src="/img/webpImg/percent.webp"
            alt="Image"
            className="sm:w-[140px] lg:w-[200px]"
          />
          <div className="flex flex-col gap-2.5 md:gap-4 items-center justify-center sm:pt-[70px] md:pt-[80px] sm:w-[60%] lg:w-[50%]">
            <h2 className="text-center sm:text-[17px] lg:text-[20px] leading-[100%] tracking-[1.1px] uppercase font-normal">
              How It Works
            </h2>
            <p className="text-center sm:text-[30px] lg:text-[40px] font-semibold leading-[110%]">
              Shop Smarter & Save Better In Just 3 Simple Steps
            </p>
          </div>
          <img
            src="/img/webpImg/percent.webp"
            alt="Image"
            className="scale-x-[-1] sm:w-[140px] lg:w-[200px]"
          />
        </div>

        <div className="flex justify-between px-4 sm:px-8 lg:px-28">
          {worksData.map((data, index) => (
            <div
              className="flex flex-col gap-6 max-w-[340px] justify-center items-center text-center w-[30%]"
              key={index}
            >
              <img
                src={data.image}
                alt="Image"
                className="max-h-[80px] h-[50%]"
              />
              <div className="flex flex-col gap-3 h-[50%]">
                <p className="text-[18px] md:text-[20px] font-semibold leading-[100%]">
                  {data.heading}
                </p>
                <p className="text-[14px] md:text-[16px] leading-[110%]">
                  {data.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="px-4 sm:px-8 lg:px-28 max-h-[177px]">
        <div className="bg-[#7149DC] my-6 rounded-[23px] translate-y-[-50%] shadow-customWork px-[2.5vw]  flex justify-between items-center h-[350px]">
          <div className="flex flex-col gap-[40px] py-[55px] md:py-[67px] lg:py-[79px]">
            <img
              src="/img/webpImg/Tbd-White-Logo.webp"
              alt="Logo"
              className="w-[160px]"
            />
            <div className="flex flex-col gap-5">
              <p className="px-5 py-[7px] rounded-[8px] text-[#000] text-[15px] font-bold leading-[103%] bg-gradient-to-r from-[#FFE466] to-[#FBC13B] w-fit">
                NEVER MISS A DEAL!
              </p>
              <p className="text-[#FFF] font-normal leading-[109%] text-[28px]">
                Steal The <span className="font-bold"> Best Loot Deals</span>{" "}
                <p>
                  From Your <span className="font-bold">Favourite Stores.</span>
                </p>
              </p>
            </div>
          </div>
          <div className=" object-contain w-[400px] h-full ">
            <img
              src="/img/TBDVideo.gif"
              alt="the best deals preview"
              className="object-cover h-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Works;
